import React from "react";
import { Table } from "react-bootstrap";

export default class MinistryIssuesReport extends React.Component {
  render() {
    const { misData } = this.props;
    return (
      <Table responsive striped hover size="sm" className="mis-project-list">
        <thead>
          <tr>
            <th className="first-child">Issue Pending With</th>
            <th className="last-child">Count</th>
          </tr>
        </thead>
        <tbody>
          {misData &&
            misData.data &&
            misData.data.map((data, index) => {
              return (
                <tr key={index}>
                  <td className="first-child" title={data.name}>
                    {data.name}
                  </td>
                  <td className="last-child">{data.number}</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    );
  }
}
